import { TelemetryService } from './modules/shared/services/TelemetryService';
import Vue from 'vue';
import './registerServiceWorker';
import router from './router';

import { VueDiContainer } from 'vue-di-container';

// Plugins
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';
import initializeApplication from '@/plugins/application-initialization';
import najizMui from '@moj/najiz-mui';
import najizToaster, { IToasterAPI } from '@moj/najiz-toastify';
import trackingController, { TrackerElement } from '@moj/najiz-tracking';

// Components
import App from './App/app';
import PersonaContainer from './modules/shared/components/persona/persona-container/PersonaContainer';
import GovernmentalPersona from './modules/shared/components/persona/governmental-persona/GovernmentalPersona';
import LawyerPersona from './modules/shared/components/persona/lawyer-persona/LawyerPersona';
import IndividualPersona from './modules/shared/components/persona/individual-persona/IndividualPersona';
import AnonymousPersona from './modules/shared/components/persona/anonymous-persona/anonymous Persona';
import BusinessPersona from './modules/shared/components/persona/business-persona/BusinessPersona';
import BasePersona from './modules/shared/components/persona/base-persona/BasePersona';

import HttpService from './modules/shared/services/httpService';
import UserService from './modules/shared/services/userService';
import SharedDataService from './modules/shared/services/sharedDataService';
import LoaderService from './modules/shared/services/loaderService';
import AxiosService from './services/AxiosService';
import surveyview from '@t2/QaimPackage';
import DateViewerComponent from '@/modules/shared/components/DateViewerComponent/DateViewerComponent.vue'
import '@t2/QaimPackage/dist/surveyview.css';



// styles
import './assets/styles/main.scss';

// filters
import "./filters"

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(VueDiContainer);
Vue.use(najizMui);
Vue.use(najizToaster);

Vue.component('BasePersona', BasePersona);
Vue.component('PersonaContainer', PersonaContainer);
Vue.component('AnonymousPersona', AnonymousPersona);
Vue.component('IndividualPersona', IndividualPersona);
Vue.component('BusinessPersona', BusinessPersona);
Vue.component('GovernmentalPersona', GovernmentalPersona);
Vue.component('LawyerPersona', LawyerPersona);
Vue.component('TrackerElement', TrackerElement);
Vue.component('surveyview', surveyview);
Vue.component('DateViewerComponent', DateViewerComponent);


declare module 'vue/types/vue' {
  interface Vue {
    $appInsights: any;
    $nToaster: IToasterAPI;
    trackingController: any;
    $user: any;
    $appConfig: any;
  }
}

declare global {
  interface Window {
    ShowLoader(): void;
    HideLoader(): void;
  }
}

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';

initializeApplication().then(() => {
  const userService = new UserService();
  userService.httpService = new HttpService();
  userService.httpService.loaderService = new LoaderService();

  // Vue.use(trackingController, {
  //   router,
  //   http,
  //   appInfo: window.$config.ApplicationInsights,
  //   userService,
  // });
  new Vue({
    i18n,
    router,
    vuetify,
    diProvide: [
      LoaderService,
      HttpService,
      UserService,
      SharedDataService,
      AxiosService,
      TelemetryService
    ],
    render: (h) => h(App),
  }).$mount('#app');
});
